import { HostContext } from "@buzzeasy/shared-frontend-utilities";
import { PropsWithChildren, ReactElement, useContext } from "react";
import AntDesignThemeProvider from "./AntDesignThemeProvider";
import StyledThemeProvider from "./StyledThemeProvider";

/**
 * Handles the Ant Design and styled-components theme providers.
 *
 * **Provider dependencies:**
 * - TranslationProvider (because of antd locale)
 */
export default function ThemeProviders({ children }: PropsWithChildren): ReactElement {
  const { theme } = useContext(HostContext);

  return (
    <AntDesignThemeProvider theme={theme}>
      <StyledThemeProvider>
        {children}
      </StyledThemeProvider>
    </AntDesignThemeProvider>
  );
}
